export const ANIMATION_TIMEOUT = 300;
